import { Reducer } from "redux";

import { RegisterUserResponse } from "../models/api/User";
import { RegisterUserActionDispatchTypes } from "../constants/User";
import { RegisterUserActionTypes } from "../models/dispatchTypes/User";

const initialState: RegisterUserResponse = {
  loading: false,
  response: {
    portalUserIdToken: "",
    displayName: "",
    email: "",
    password: "",
  },
  error: null,
};

const RegisterUserReducer: Reducer<
  RegisterUserResponse,
  RegisterUserActionTypes
> = (state = initialState, action) => {
  switch (action.type) {
    case RegisterUserActionDispatchTypes.POST_REGISTER_USER_INVOKE: {
      return {
        ...state,
        loading: true,
      };
    }
    case RegisterUserActionDispatchTypes.POST_REGISTER_USER_SUCCESS: {
      return {
        ...state,
        response: action.response,
        loading: false,
      };
    }
    case RegisterUserActionDispatchTypes.POST_REGISTER_USER_ERROR: {
      return {
        ...state,
        error: action.error,
        loading: false,
      };
    }
  }
  return state;
};

export default RegisterUserReducer;
